import src from "IMAGE";
export default { src, width: 4817, height: 650, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJSUlNU+Pj5TNDQ0PTAwMDkjIyMpNDQ0PTMzMz0uLi42o4YIQqlB6iAAAAAASUVORK5CYII="};
